import { createContext, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { UI } from "./ui";

const LanguageContext = createContext({ lang: "fr", T: UI.fr });

export function LanguageProvider({ children }) {
  const location = useLocation();
  const lang = location.pathname === "/nl" || location.pathname.startsWith("/nl/") ? "nl" : "fr";

  useEffect(() => {
    document.documentElement.lang = lang === "nl" ? "nl-BE" : "fr-BE";
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, T: UI[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);

const BASE = "https://devismaison.be";

export function Hreflang({ frPath, nlPath }) {
  return (
    <Helmet>
      <link rel="alternate" hrefLang="fr-BE" href={`${BASE}${frPath}`} />
      <link rel="alternate" hrefLang="fr-LU" href={`${BASE}${frPath}`} />
      <link rel="alternate" hrefLang="nl-BE" href={`${BASE}${nlPath}`} />
      <link rel="alternate" hrefLang="x-default" href={`${BASE}${frPath}`} />
    </Helmet>
  );
}
